<template>
  <nk-page :body-class="'nk-page-body-without-scroll'" commercialAccess="Salary" :policyClaims="['Salary_Personnel_Management']">
    <template #badges>
      <nk-badge system="salary">
        <nk-badge-item type="system" modelValue="salary"></nk-badge-item>
        <nk-badge-item type="system" modelValue="salary" :title="$t('forms.PersonnelList')"></nk-badge-item>
      </nk-badge>
    </template>
    <div class="h-100 d-flex flex-column form-container overflow-auto">
      <div class="h-grow-lock pt-3">
        <ag-grid :options="componentOptions.tableOption" :data="personnelList" v-model="selectedRow" ref="personnelList" :key="tableKey" tabindex="101" startup class="nk-card" @preSelectedRowData="(data: Personnel) => selectedRow = data" @row_dbClicked="rowDbClicked"></ag-grid>
      </div>
    </div>
  </nk-page>
</template>
<script lang="ts">
  import { post } from '~/plugins/nikan-api'
  import $sc from '~/plugins/shortcut.collection.js'
  import Endpoints from '@nikan/endpoints'
  import { defineComponent } from 'vue'
  import { Personnel } from '@/classes/salary/personnel'
  import { IResponseList } from '@/interfaces/base'

  export default defineComponent({
    name: 'personnel-selector',
    modal: {
      size: 'fullscreen',
      stateUID: 'personnel-selector',
    },
    props: {
      options: { type: Object },
      data: { type: Object },
    },
    data() {
      return {
        tableKey: new Date(),
        personnelList: [] as Personnel[],
        selectedRow: {} as Personnel,
        componentOptions: {
          tableOption: {
            id: this.$options.name,
            pagination: false,
            groupIncludeTotalFooter: true,
            cellSelectionAggReport: false,
            enterToSelect: true,
            rowSelection: {
              mode: 'singleRow'
            },
            columnDefs: [
              {
                field: 'code',
                headerName: this.$t('salary.personnel.f.code'),
                contentType: 'number',
                width: 100,
                sort: 'asc',
                aggFunc: 'count'
              },
              {
                field: 'firstName',
                headerName: this.$t('salary.personnel.f.firstName'),
                contentType: 'string',
                width: 100,
              },
              {
                field: 'lastName',
                headerName: this.$t('salary.personnel.f.lastName'),
                contentType: 'string',
                width: 100,
              },
              {
                field: 'nationalCode',
                headerName: this.$t('salary.personnel.f.nationalCode'),
                contentType: 'string',
                width: 100,
              },
              {
                field: 'fatherName',
                headerName: this.$t('salary.personnel.f.fatherName'),
                contentType: 'string',
                width: 100,
              },
              {
                field: 'mobile1',
                headerName: this.$t('salary.personnel.f.mobile1'),
                contentType: 'string',
              },
            ]
          },
        },
        selectPersonnelButton: {
          title: this.$t('select'),
          shortcut: $sc.find('enter-only'),
          icon: 'check',
          element: () => this.$refs.personnelList.$el,
          isPrimary: true,
          handle: () => {
            this.resolve(this.selectedRow)
          },
          policyClaims: 'Salary_Personnel_Management',
        },
      }
    },
    mounted() {
      this.prepareWindow(this.$t('salary.personnel.personnel-list'), [this.selectPersonnelButton])

      this.getPersonnelList()
    },
    methods: {
      getPersonnelList() {
        var wait = this.$wait(this.$refs.personnelList.$el)
        post(Endpoints.getUrl('personnel.list'), {})
          .then((result: IResponseList<Personnel>) => {
            wait.end()
            this.personnelList = result.data.items
            this.tableKey = new Date()
          })
          .catch(() => {
            wait.end()
          })
      },
      rowDbClicked(val: Personnel) {
        this.resolve(val)
      },
    },
  })
</script>
